// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"640":"eeb4f7c2b5e3c52c0dbf","1656":"05d90ab05fafdbaeed35","2983":"6b1f4987e70a54683ca4","3485":"b3e801849a79b5a466ec","5771":"a4e2a98efcfb7393c5bd","5810":"8dfb2392d7107957a510","6127":"1de3ccb45fe0f97ce88e"}[chunkId] + "";
};